import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class PaymentsService extends BaseService {
  static get entity() {
    return 'payments'
  }

  static async getList(params = {}) {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}?${this.querystring(params)}`
      )

      const data = {
        content: response.data.data,
        total: response.data.total,
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async setUnhandledPayment(payload = {}) {
    try {
      const response = await this.request({ auth: true }).patch(`${this.entity}/${payload.id}`, {
        domain: payload.application,
      })

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async delPayment(payload = {}) {
    try {
      const response = await this.request({ auth: true }).delete(`${this.entity}/${payload.id}`)

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async unlinkedCount(payload = {}) {
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/unlinked-count`)

      const data = {
        content: response.data.count,
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
